import {
  CircleCheck,
  CircleClose,
  CircleCloseFilled,
  Close,
  InfoFilled,
  Loading,
  SuccessFilled,
  WarningFilled,
} from '@element-plus/icons-vue'
import {
  IconSmallCross,
  IconCross,
  IconDanger,
  IconInfo,
  IconSuccess,
  IconWarning,
} from '../../components/cig-icon'
import { definePropType } from './props'
import type { Component } from 'vue'

export const iconPropType = definePropType<string | Component>([
  String,
  Object,
  Function,
])

export const CloseComponents = {
  IconCross,
}

export const TypeComponents = {
  IconSmallCross,
  IconCross,
  Close,
  SuccessFilled,
  InfoFilled,
  WarningFilled,
  CircleCloseFilled,
}

export const TypeComponentsMap = {
  success: IconSuccess,
  warning: IconWarning,
  error: IconDanger,
  info: IconInfo,
}

export const ValidateComponentsMap = {
  validating: Loading,
  success: CircleCheck,
  error: CircleClose,
}
